import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LibService } from './libService';

@Injectable({
  providedIn: 'root'
})
export class CollectionsService {
  baseApi = environment.rootApiCollections;

  constructor(public libService: LibService) { }

  getCollections(usr: string, practice:string) {

    let py = {
     incasso: {
        Id: '',
        Commessa: practice,
        CommessaId: '',
        Sede: '',
        Responsabile: '',
        DataInizio: '',
        DataFine: '',
        TipoSocieta: '',
        Stato: '',
        SocietaId: ''
      }
    };
    return this.libService.postData<any>(py, this.baseApi, '?account=' + usr);

  }

}
